import type {PS} from '@wix/document-services-types'
import {createHttpClient} from '@wix/http-client'
import clientSpecMap from '../siteMetadata/clientSpecMap'
import platformConstants from '../platform/common/constants'

export function getHttpClient(ps: PS) {
    const {editorRootUrl} = ps.dal.get(ps.pointers.general.getServiceTopology())

    return createHttpClient({
        artifactId: process.env.ARTIFACT_ID,
        baseURL: editorRootUrl,
        getAppToken: () => {
            const appData = clientSpecMap.getAppData(ps, platformConstants.APPS.META_SITE.applicationId)
            return appData.instance
        }
    })
}
